import type { GetLevelTagsResponse } from '@gdladder/shared/features';
import APIClient from '../APIClient';

class LevelTagsClient {
    async getLevelTags(levelID: number) {
        const res = await APIClient.get<GetLevelTagsResponse>(`/levels/${levelID}/tags`);
        return res.data;
    }

    async removeVotes(levelID: number, tagID: number) {
        await APIClient.delete(`/levels/${levelID}/tags/${tagID}`);
    }
}

export const levelTagsClient = new LevelTagsClient();
